// extracted by mini-css-extract-plugin
export default {"tableRow":"TableRow_tableRow__chgVa","tableCell":"TableRow_tableCell__Zokw5","clickable":"TableRow_clickable__VtQ2B","headerRow":"TableRow_headerRow__RuFDa"};